import {
	GET_PII_DETAILS_REQUEST,
	GET_PII_DETAILS_REQUEST_SUCCESS,
	GET_PII_DETAILS_REQUEST_FAILED,
	GET_PII_DETAILS_REQUEST_FAILED_CLEAR,
} from "../types"

const initialState = {
	isLoading: false,
	piiDetails: {},
}
const bifrostPiiDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PII_DETAILS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_PII_DETAILS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				piiDetails: action.payload,
			}
		case GET_PII_DETAILS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
				piiDetails: {},
			}
		case GET_PII_DETAILS_REQUEST_FAILED_CLEAR:
			return initialState

		default:
			return state
	}
}

export default bifrostPiiDetailsReducer
